import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Base64UrlService } from '../../../services/base64url.service';
import { ModalService } from '../../../core/services/modal.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';

@Component({
    selector: 'tt-doc-pack-type-chapter',
    templateUrl: './doc-pack-type-chapter.component.html',
    styleUrls: ['./doc-pack-type-chapter.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocPackTypeChapterComponent implements OnChanges {
    @Input()
    public params?: GetDocPackTypeChapterParams;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    @Output()
    public submit = new EventEmitter<DocPackTypeChapterSubmitEvent>();

    constructor(
        private base64: Base64UrlService,
        private modal: ModalService,
        private datatask: DataTaskService,
        private cdr: ChangeDetectorRef,
    ) {}

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
                this.cdr.markForCheck();

                const response = await this.saveDocPackTypeChapter({ ...this.edit, html_text: this.base64.urlEncode(this.edit.html_text) });

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage,
                    });
                } else {
                    this.submit.emit({ docpacktype_keyno: '' + this.edit.docpacktype_keyno, docpacktypechapter_keyno: response.docpacktypechapter_keyno, type: '' + this.edit.docpacktypechapter_keyno === '0' ? 'new' : 'update' });
                }
            } finally {
                this.saving = false;
                this.cdr.markForCheck();
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;
                this.cdr.markForCheck();

                const deleteConfirmed = await this.modal.openConfirmDialog({ title: 'confirm_title', translateMessage: true, message: 'confirm_message', type: 'danger' });

                if (deleteConfirmed) {
                    const response = await this.deleteDocPackTypeChapter(this.edit);

                    if (response.errorcode !== '0') {
                        this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
                    } else {
                        this.submit.emit({ docpacktype_keyno: '' + this.edit.docpacktype_keyno, docpacktypechapter_keyno: '' + this.edit.docpacktypechapter_keyno, type: 'delete' });
                    }
                }
            } finally {
                this.deleting = false;
                this.cdr.markForCheck();
            }
        }
    }

    private async loadEdit() {
        if (!!this.params) {
            this.edit = await this.getDocPackTypeChapter(this.params);
            this.edit.html_text = this.base64.urlDecode(this.edit.html_text);
            this.cdr.markForCheck();
        }
    }

    private async getDocPackTypeChapter(params: GetDocPackTypeChapterParams): Promise<Edit> {
        return (await this.datatask.Post(3279, params))[0];
    }

    private async saveDocPackTypeChapter(params: Edit): Promise<SaveDocPackTypeChapterResponse> {
        return (await this.datatask.Post(3280, params))[0];
    }

    private async deleteDocPackTypeChapter(params: Edit): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3281, params))[0];
    }

    private async init() {
        delete this.edit;
        this.cdr.markForCheck();
        await this.loadEdit();
        this.cdr.markForCheck();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}

export interface SaveDocPackTypeChapterResponse extends ErrorMessageResponse {
    docpacktypechapter_keyno: string;
}

export interface GetDocPackTypeChapterParams {
    docpacktypechapter_keyno: string;
    docpacktype_keyno: string;
}

export interface DocPackTypeChapterSubmitEvent {
    docpacktypechapter_keyno: string;
    docpacktype_keyno: string;
    type: 'delete' | 'new' | 'update';
}

interface Edit {
    docpacktypechapter_keyno: number;
    docpacktypechapter_name: string;
    docpacktypechapter_order: number;
    docpacktype_keyno: number;
    html_text: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docPackTypeChapter', {
//        templateUrl: 'views/components/views/docPackTypeChapter/docPackTypeChapter.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'base64', 'modalService', 'translateService', 'docPackTypeChapterService', function ($stateParams, stateService, base64, modalService, translateService, docPackTypeChapterService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let docPackTypeKeyno = $stateParams.docpacktype_keyno;
//            let docPackTypeChapterKeyno = $stateParams.docpacktypechapter_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                docPackTypeChapterKeyno: docPackTypeChapterKeyno,
//                edit: {},
//                readyHtmlText: true,
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await docPackTypeChapterService.getEdit({
//                    docpacktype_keyno: docPackTypeKeyno,
//                    docpacktypechapter_keyno: docPackTypeChapterKeyno
//                }))[0];

//                vm.model.edit.html_text = base64.urldecode(vm.model.edit.html_text);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let editAndSave = {
//                    docpacktypechapter_keyno: vm.model.edit.docpacktypechapter_keyno,
//                    docpacktypechapter_name: vm.model.edit.docpacktypechapter_name,
//                    docpacktypechapter_order: vm.model.edit.docpacktypechapter_order,
//                    docpacktype_keyno: vm.model.edit.docpacktype_keyno,
//                    html_text: base64.urlencode(vm.model.edit.html_text)
//                };

//                docPackTypeChapterService.saveObj(editAndSave).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    docPackTypeChapterService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
